import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import Api from "../../services/Api";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTimes } from '@fortawesome/free-solid-svg-icons';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        tipoEtapas: [],
        arrayResultado: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state.arrayResultado;
        state[e.target.name] = e.target.value;
        this.setState({ arrayResultado: state });
    };
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const nombre = document.getElementById('nombre').value;
        var errores = [];
        if (!nombre) { errores.push("error_nombre"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(formData);
        Swal.showLoading();
        authAxios.post("tipo_etapas/editar", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.close();
                Swal.fire(
                    'Tipo Etapas!',
                    datosRespuesta.data.msj,
                    'success'
                )
                this.props.history.push("/MasterTipoEtapas");
            })
            .catch(console.log)
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("tipo_actuaciones/ver/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, arrayResultado: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
        authAxios.get("tipo_etapas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.Status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({
                    datosCargados: true,
                    tipoEtapas: datosRespuesta.data.data,
                    load: ''
                });
            })
        .catch(console.log);
    }
    render() {
        const { load, tipoEtapas, arrayResultado } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>EDITAR TIPO ETAPA</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="form">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className='col-md-4'>
                                                    <label htmlFor="ID_TIPO_ETAPA">Etapa Judicial</label>
                                                    <select name="ID_TIPO_ETAPA"
                                                        id="ID_TIPO_ETAPA"
                                                        value={arrayResultado.ID_TIPO_ETAPA}
                                                        options={arrayResultado.ID_TIPO_ETAPA}
                                                        className={((this.verificarError("error_id_tipo_etapa")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione la Etapa Judicial</option>
                                                        {
                                                            tipoEtapas.map((itemTipoEtapa) => (
                                                                <option key={itemTipoEtapa.ID_TIPO_ETAPA} value={itemTipoEtapa.ID_TIPO_ETAPA}>{itemTipoEtapa.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Etapa Judicial</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <input type="hidden" name="id" value={this.props.match.params.id} />
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombre" id="nombre" defaultValue={arrayResultado.NOMBRE}
                                                        className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="NOMBRE" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar Actuación Judicial</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterTipoActuaciones"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;